import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { DeepLinkService } from "@shared/services/deeplink/deeplink.service";
import { RequestedRouteService } from "../services/requested-route.service";

export const AuthGuard: CanActivateFn = async (route, state) => {
	const authService = inject(AuthService);
	const deepLinkService = inject(DeepLinkService);
	const requestedRouteService = inject(RequestedRouteService);

	const path = route.routeConfig?.path;

	if (["callback", "logout", "sessionexpired"].includes(path || "")) return true;

	// PRESERVE DEEP LINK PARAMS FIRST - before any auth checks
	if (deepLinkService.hasRelevantParams(route.queryParams)) {
		deepLinkService.preserveDeepLinkFromUrl();
	}

	const hasValidSession = await authService.validateUserSession(false);
	if (hasValidSession) {
		return true;
	}

	if (!deepLinkService.hasRelevantParams(route.queryParams)) {
		requestedRouteService.store(state.url);
	}

	// Force renew/login if session is invalid.
	return authService.validateUserSession(true);
};
